import Axios from "axios/dist/axios.min.js";
import utils from './utils';

const Request = async({ url, method = 'get', params = {}, data = {}, headers = {} } = {}) => {
  if (utils.isShihuo()) {
    return new Promise((resolve, reject) => {
      window.Jockey.send('request', {
        url: url,
        type: method === 'get' ? 'GET' : 'POST',
        header: {
          'Content-Type': 'application/json',
          'User-Agent': navigator.userAgent,
          ...headers
        },
        withCookie: true,
        data: method === 'get' ? params : data
      }, (res) => {
        if (!utils.isAndroid()) {
          res.data = JSON.parse(res.response.body);
        } else {
          res.data = res.response.body;
        }
        resolve(res);
      })
    });
  } else {
    const options = {
      url: url,
      method: method,
      headers: headers,
      withCredentials: true,
    }
    if (method === 'get') {
      Object.assign(options, {
        params: params
      });
    } else if (method === 'post') {
      Object.assign(options, {
        data: data
      });
    }
    return await Axios(options);
  }
}

export default Request;


// WEBPACK FOOTER //
// ./utils/request.js